/* global axios */
import ApiClient from './ApiClient';

class WahaInboxesAPI extends ApiClient {
  constructor() {
    super('waha_inboxes', { accountScoped: true });
  }

  createInbox(name) {
    return axios.post(this.url, { name });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/status`);
  }

  deleteInbox(inboxId) {
    return axios.delete(`${this.url}/${inboxId}`);
  }
}

export default new WahaInboxesAPI();
